import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

export default function AgentRegister() {
  const [lang] = useState(() => localStorage.getItem("lang") || "en");
  const [form, setForm] = useState({ name: "", email: "", password: "", agency: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      toast.success("Welcome to Aegis — 90-day trial activated");
      navigate("/agent/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/agent/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 grain">
      <div className="w-full max-w-md relative z-10 py-14">
        <Link to="/" className="font-display text-lg font-medium tracking-tight flex items-center gap-2 mb-10">
          <span className="w-6 h-6 grid place-items-center bg-black text-white font-black">Æ</span>
          Aegis Realtor
        </Link>
        <h1 className="font-display text-4xl font-black tracking-tighter mb-2">{t(lang, "createAccount")}</h1>
        <p className="text-sm text-muted-foreground mb-8">90-day free trial · No credit card</p>

        <form onSubmit={submit} className="space-y-4">
          {["name", "agency", "phone", "email", "password"].map((k) => (
            <div key={k}>
              <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-muted-foreground">{t(lang, k) || k}</label>
              <input
                data-testid={`register-${k}`}
                type={k === "password" ? "password" : k === "email" ? "email" : k === "phone" ? "tel" : "text"}
                required={k !== "agency" && k !== "phone"}
                placeholder={k === "phone" ? "+90 555 123 4567" : ""}
                value={form[k]}
                onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))}
                className="w-full mt-2 px-4 py-3 bg-white hairline focus:border-black outline-none"
              />
            </div>
          ))}
          <button
            data-testid="register-submit"
            disabled={busy}
            className="w-full py-3 bg-black text-white font-bold tracking-wide hover:opacity-90 disabled:opacity-40"
          >
            {t(lang, "createAccount")}
          </button>
        </form>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px bg-[var(--line)]" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground">{t(lang, "or")}</span>
          <div className="flex-1 h-px bg-[var(--line)]" />
        </div>

        <button
          data-testid="register-google"
          onClick={google}
          className="w-full py-3 hairline bg-white font-bold hover:bg-[var(--paper-2)]"
        >
          {t(lang, "google")}
        </button>

        <p className="text-sm text-muted-foreground mt-8">
          {t(lang, "already")}{" "}
          <Link data-testid="link-login" to="/agent/login" className="text-black underline underline-offset-4">
            {t(lang, "signIn")}
          </Link>
        </p>
      </div>
    </div>
  );
}
